import { Chart1 } from 'iconsax-react';
import { CallAdd } from 'iconsax-react';

// icons
const icons = {
    navigation: Chart1,
    CalendarTick: CallAdd,
};


const Analytics = {
      id: "Analytics",
      title: "Analytics",
      icon: icons.navigation,
      type: "group",
      children: [
        {
              id: "all-analytics",
              title: "Analytics",
              type: "item",
              url: "/analytics/all-analytics",
              icon: icons.navigation,
              breadcrumbs: true,
            },
        {
              id: "all-leads_management",
              title: "Leads Management",
              type: "item",
              url: "/leads_management/all-leads_management",
              icon: icons.CalendarTick,
              breadcrumbs: true,
            },
      ],
    };

export default Analytics;
